import { mutatorAction } from 'satcheljs';
import { getAppStore } from '..';

export const onLocaleChanged = mutatorAction('onLocaleChanged', (locale?: string) => {
  if (locale) {
    // locale: en-us
    getAppStore().locale = locale.split('-')[0];
  }
});
